import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { RuntimeEnvironments } from '@src/app/models/runtime-enviroment.enum';
import { EnvironmentService } from '@service/environment.service';
import { EditFlgService } from '@service/editflg.service';
import { HttpStatusCode } from '@angular/common/http';
import { AuthService } from '@service/auth.service';
import { UserPictureService } from '@service/user-picture.service';

@Injectable()
export class AuthGuard {
    private env: RuntimeEnvironments;
    constructor(
        private router: Router,
        private authService: AuthService,
        private environmentService: EnvironmentService,
        private userPictureService: UserPictureService,
        private editFlg: EditFlgService
    ) {
        this.env = this.environmentService.getEnvironment();
    }

    async canActivate() {
        try {
            if (this.env == RuntimeEnvironments.ELECTRON) {
                const currentUserOid = this.authService.getCurrentUser().oid;
                if (currentUserOid) {
                    const currentUserName = this.authService.getCurrentUser().name;
                    this.userPictureService.setUserPicture(currentUserOid, currentUserName);
                    return true;
                } else {
                    this.router.navigate(['/electronLogin']);
                    return false;
                }
            }

            const authCheck = await this.authService.isAuthenticated();
            if (authCheck.isAuthenticated) {
                this.editFlg.clientAccountName = authCheck.name;
                this.editFlg.clientAccountOID = authCheck.oid;
                this.authService.setCurrentUser(authCheck.name, authCheck.oid, authCheck.email);
                if (authCheck.oid) {
                    this.userPictureService.setUserPicture(authCheck.oid, authCheck.name);
                }
                return true;
            } else {
                this.router.navigate(['/iCreateLogin']);
                return false;
            }
        } catch (error) {
            if (
                this.env != RuntimeEnvironments.ELECTRON &&
                (error.status === HttpStatusCode.Unauthorized || error.status === HttpStatusCode.Forbidden)
            ) {
                this.router.navigate(['/iCreateLogin']);
            }
        }
    }
}
